(() => {
  const STORAGE_KEY = 'minico:wishlist:v1';

  const readWishlist = () => {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(value) ? [...new Set(value.filter((item) => typeof item === 'string'))] : [];
    } catch {
      return [];
    }
  };

  const writeWishlist = (items) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items } }));
  };

  const updateControls = () => {
    const items = readWishlist();
    const saved = new Set(items);

    document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
      count.textContent = items.length > 0 ? items.length : '';
    });

    document.querySelectorAll('[data-wishlist-product]').forEach((button) => {
      const isSaved = saved.has(button.dataset.wishlistProduct);
      button.classList.toggle('is-active', isSaved);
      button.setAttribute('aria-pressed', String(isSaved));
      button.setAttribute('aria-label', isSaved ? 'Elimină din favorite' : 'Adaugă la favorite');
      const label = button.querySelector('[data-wishlist-label]');
      if (label) label.textContent = isSaved ? 'Salvat la favorite' : 'Adaugă la favorite';
    });
  };

  const toggleProduct = (handle) => {
    const items = readWishlist();
    const index = items.indexOf(handle);
    if (index === -1) items.push(handle);
    else items.splice(index, 1);
    writeWishlist(items);
  };

  const createProductCard = (product) => {
    const item = document.createElement('li');
    item.className = 'wishlist-page__item grid__item';

    const card = document.createElement('article');
    card.className = 'wishlist-card';

    const imageLink = document.createElement('a');
    imageLink.className = 'wishlist-card__media';
    imageLink.href = product.url;

    if (product.featured_image) {
      const image = document.createElement('img');
      image.src = product.featured_image;
      image.alt = product.title;
      image.loading = 'lazy';
      image.width = 533;
      image.height = 667;
      imageLink.append(image);
    }

    const info = document.createElement('div');
    info.className = 'wishlist-card__info';

    const title = document.createElement('h2');
    title.className = 'wishlist-card__title h5';
    const titleLink = document.createElement('a');
    titleLink.href = product.url;
    titleLink.textContent = product.title;
    title.append(titleLink);

    const price = document.createElement('div');
    price.className = 'wishlist-card__price';
    const currency = window.Shopify?.currency?.active || 'RON';
    price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'ro-RO', {
      style: 'currency',
      currency,
    }).format(product.price / 100);

    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'wishlist-card__remove link underlined-link';
    remove.dataset.wishlistProduct = product.handle;
    remove.textContent = 'Elimină';

    info.append(title, price, remove);
    card.append(imageLink, info);
    item.append(card);
    return item;
  };

  const renderWishlistPage = async () => {
    const container = document.querySelector('[data-wishlist-page]');
    if (!container) return;

    const grid = container.querySelector('[data-wishlist-grid]');
    const empty = container.querySelector('[data-wishlist-empty]');
    const loading = container.querySelector('[data-wishlist-loading]');
    const handles = readWishlist();

    grid.replaceChildren();
    loading.hidden = handles.length === 0;
    empty.hidden = true;

    if (handles.length === 0) {
      loading.hidden = true;
      empty.hidden = false;
      return;
    }

    const products = await Promise.all(
      handles.map(async (handle) => {
        try {
          const response = await fetch(`${window.Shopify.routes.root}products/${encodeURIComponent(handle)}.js`);
          return response.ok ? response.json() : null;
        } catch {
          return null;
        }
      }),
    );

    const availableProducts = products.filter(Boolean);
    availableProducts.forEach((product) => grid.append(createProductCard(product)));
    loading.hidden = true;
    empty.hidden = availableProducts.length > 0;

    if (availableProducts.length !== handles.length) {
      writeWishlist(availableProducts.map((product) => product.handle));
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-product]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    toggleProduct(button.dataset.wishlistProduct);
  });

  document.addEventListener('wishlist:change', () => {
    updateControls();
    renderWishlistPage();
  });

  document.addEventListener('shopify:section:load', updateControls);
  document.addEventListener('DOMContentLoaded', () => {
    updateControls();
    renderWishlistPage();
  });
})();
